import React, {Component} from 'react'
import moment from 'moment-timezone';

export default class Footer extends Component {
  render () {
    return (
      <footer  className="fixed-bottom footer d-none d-md-block">
        Powered by <a href="https://my-air-seat.com/" target="_blank">www.my-air-seat.com</a>
      </footer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Layout/Footer.js